import useAuthStore from '@/stores/useAuthStore'
import * as Sentry from '@sentry/browser'
import { useEffect } from 'react'

const useDefinedSentryUser = () => {
    const { employee } = useAuthStore()

    useEffect(() => {
        if (import.meta.env.DEV) return

        if (employee) {
            Sentry.setUser({
                email: employee.employee_email_company,
            })
        }
    }, [employee])
}

export default useDefinedSentryUser
